/**
 * X / Twitter post embed helpers, used by the shared TinyMCE `media_url_resolver`.
 * Generates the official platform.twitter.com iframe embed (no video download/S3).
 */

const TWITTER_STATUS_RE =
  /^(?:https?:\/\/)?(?:www\.)?(?:x\.com|twitter\.com)\/([A-Za-z0-9_]{1,15})\/status\/(\d+)(?:[/?#].*)?$/i;

/**
 * @param {string} rawUrl
 * @returns {{ username: string, statusId: string, canonicalUrl: string } | null}
 */
export const parseTwitterStatusUrl = (rawUrl) => {
  const trimmed = String(rawUrl || "").trim();
  if (!trimmed) return null;

  let candidate = trimmed;
  try {
    const parsed = new URL(
      /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`
    );
    candidate = `${parsed.hostname}${parsed.pathname}`;
  } catch {
    return null;
  }

  const match = candidate.match(TWITTER_STATUS_RE);
  if (!match) return null;

  const username = match[1];
  const statusId = match[2];

  return {
    username,
    statusId,
    canonicalUrl: `https://twitter.com/${username}/status/${statusId}`,
  };
};

export const isTwitterStatusUrl = (rawUrl) =>
  Boolean(parseTwitterStatusUrl(rawUrl));

/**
 * Official platform.twitter.com iframe embed for a tweet/post URL.
 * Returns "" when the URL isn't a recognizable X / Twitter status link.
 */
export const buildTwitterEmbedIframe = (rawUrl) => {
  const parsed = parseTwitterStatusUrl(rawUrl);
  if (!parsed) return "";

  return (
    `<iframe style="width: 550px; height: 480px; max-width: 100%; border: 0;" ` +
    `src="https://platform.twitter.com/embed/Tweet.html?id=${parsed.statusId}" ` +
    `allowfullscreen="allowfullscreen" allow="fullscreen"></iframe>`
  );
};
